import './App.css'

import { ToasterComponent } from './features/toaster/ui/ToasterComponent'
import Bonanza from './components/Bonanza'
import PixelScripts from './components/PixelScripts'

function App() {
    return (
        <div>
            <PixelScripts />
            <Bonanza />
            <div id="modals" />
            <ToasterComponent />
        </div>
    )
}

export default App
